module.exports = __webpack_public_path__ + "static/media/add-recipe.04d8e3a4.png";